import { defineMessages } from 'react-intl';

export const PhotoStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
  tooltip: {
    id: 'app.common.allFieldsRequired',
    defaultMessage: 'Pro pokračování je třeba vyplnit všechna povinná pole!',
  },
});
